import { ConfigState } from '@app/core/store/config/config.state';
import { AuthState } from './auth/auth.state';
import { ScreeningState } from './screening/screening.state';
import { TasksState } from './tasks/tasks.state';
import { StockEntryState } from '../tvf/stock-entry/store/stock-entry.state';
import { ChecklistState } from './checklist/checklist.state';

export const stateKeys = ['auth', 'config', 'screening', 'tasks', 'stockEntry', 'checklist'];

export const noAuthStates: any[] = [ScreeningState, TasksState, ChecklistState];

export const AppState: any[] = [AuthState, ConfigState, StockEntryState, ...noAuthStates];
